import React from "react";
import { PanelEditFaq } from "../../../UI/Faqs/Edit/PanelEditFaq";

const EditFaq = () => {
  return (
    <div>
      <PanelEditFaq />
    </div>
  );
};

export default EditFaq;
